import React, { createContext, useContext } from 'react';

const NavBarContext = createContext({
  openNavBar: false,
  setOpenNavBar: () => {},
  closeNavBar: () => {},
});

export const useNavBar = () => useContext(NavBarContext);

export default NavBarContext;
